<template>
  <div class="user-list-page">
    <div class="user-total-count">
      <p style="color: white; font-size: 15px">User Count as of {{ dateToday }} is <span style="font-size: 20px; color: red">{{ total }}</span></p>
    </div>
    <div class="user-list">
      <q-input
        v-model="userId"
        debounce="1000"
        outlined
        rounded
        input-style="font-size:12px"
        color="orange"
        placeholder="Search By User Name"
        hint-color="white"
        dense
        dark
        @update:model-value="getUserList()"
      >
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>
    </div>
    <div class="user-list-select">
    </div>
    <div class="user-list-table">
      <q-table
        bordered
        title="User List"
        :rows="tableData"
        :columns="columns"
        row-key="ID"
        separator="cell"
        dark
        :loading="loading"
        :hide-pagination="true"
        :rows-per-page-options="[15]"
        @row-click="onRowClick"
        :wrap-cells="true"
      >
      </q-table>
      <user-profile-modal
        :open="openUserProfile"
        :userNum="this.userNum"
        @close="this.openUserProfile = false"
      />
      <div class="q-pa-lg flex flex-center pagination">
        <q-pagination
          v-model="pagination.current"
          :max="pagination.last"
          direction-links
          outline
          color="orange"
          active-design="unelevated"
          active-color="brown"
          active-text-color="orange"
          @update:model-value="getUserList()"
          :max-pages="3"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import UserProfileModal from './UserProfileModal.vue'

export default {
  name: 'UserList',
  components: {
    UserProfileModal
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser'
    }),
    dateToday () {
      return moment(new Date()).format('DD MMMM YYYY hh:mm:ss A')
    },
    computedbodycellname () {
      return 'body-cell-' + this.columnSelection     
    }
  },
  data () {
    return {
      separator: { label: 'Cell', value: 'cell' },
      columnSelection: 'UserBlock',
      columnSelectionLogin: 'UserLoginState',
      columns : [
        {
          name: 'UserNum',
          align: 'center',
          label: 'ID',
          field: 'UserNum'
        },
        {
          name: 'UserID',
          align: 'center',
          label: 'User Name',
          field: 'UserID'
        },
        {
          name: 'UserBlock',
          align: 'center',
          label: 'User Block',
          field: 'UserBlock'
        },
        {
          name: 'UserLoginState',
          align: 'center',
          label: 'User Login State',
          field: 'UserLoginState'
        },
        {
          name: 'ReferralCode',
          align: 'center',
          label: 'Referral Code',
          field: 'ReferralCode'
        },
        {
          name: 'ReferralUserNum',
          align: 'center',
          label: 'Refer By',
          field: 'ReferralUserNum'
        },
        {
          name: 'UserPoint',
          align: 'center',
          label: 'EP',
          field: 'UserPoint'
        },
        {
          name: 'UserPoint2',
          align: 'center',
          label: 'Gems',
          field: 'VotePoint'
        },
        {
          name: 'LastLoginDate',
          align: 'center',
          label: 'Last Login Date',
          field: 'LastLoginDate'
        },
        {
          name: 'CreateDate',
          align: 'center',
          label: 'Date Created',
          field: 'CreateDate'
        }
      ],
      tableData: [],
      loading: true,
      pagination: {
        current: 1,
        last: 1
      },
      userId: '',
      total: 0,
      openUserProfile: false,
      userNum: 0
    }
  },
  mounted () {
    this.$q.loading.show()

    this.getUserList()

    this.$q.loading.hide()
  },
  methods: {
    ...mapActions({
      userList: 'user/userList',
    }),
    async onRowClick (evt, row) {
      if (Number(this.user.UserType) >= 30) {
        this.userNum = row.UserNum
        this.openUserProfile = !this.openUserProfile
      }
    },
    async getUserList () {
    this.loading = true
      this.tableData = []
      
      const parameter = {
        params: {
          page: this.pagination.current,
          userName: this.userId
        }
      }

      await this.recaptchaLoad('requestUserList')

      await this.userList(parameter)
        .then(response => {
          this.recaptchaLoad('requestUserList')
          const { current_page, last_page, data, total } = response.data.data
          
          this.tableData = data

          this.total = total

          this.pagination.current = current_page
          this.pagination.last = last_page

          this.loading = false
        })
        .catch(error => {
          this.loading = false

          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })
        })
    }
  }
}
</script>

<style lang="scss">
.user-list-page {
  background-color: $background;
  padding: 24px;
  border-radius: 5px;

  .user-list {
    margin-bottom: 16px;
  }
}
</style>